import styled from 'styled-components'

export const SidecarPhoneNumber = styled.a`
  white-space: nowrap;
  word-break: keep-all;
  ${p =>
    p.inverted &&
    `
    color: #fff;
    text-decoration: underline;
  `}
`
